import DateRangeFields from '../shared/ui/DateRangeFields'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import OrderCard from '../entities/order/ui/OrderCard'
import { useOrderListData } from '../features/order-list/useOrderListData'
import './Ros.css'
import './Master.css'

const metricConfig = [
    { key: 'all', label: 'Все', bg: '#0052FF', icon: 'ti-list', area: 'all' },
    { key: 'open', label: 'Новые', bg: '#FF7438', icon: 'ti-clock', area: 'open' },
    { key: 'in_progress', label: 'В работе', bg: '#F59E0B', icon: 'ti-tool', area: 'prog' },
    { key: 'done', label: 'Завершено', bg: '#10B981', icon: 'ti-check', area: 'done' },
    { key: 'expired', label: 'Просрочено', bg: '#DC2626', icon: 'ti-alert-triangle', area: 'exp' },
]

const getMetricSubtext = (key, counts) => {
    if (key === 'done') return `${counts.doneSent} SMS · ${counts.doneNotSent} без SMS`
    if (key === 'expired') return `${counts.expiredOpen} пропущено · ${counts.expiredProgress} брошено`
    return null
}

export default function Mechanic() {
    const { token } = useAuth()
    const navigate = useNavigate()

    const {
        loading,
        period, setPeriod,
        filterFrom, setFilterFrom,
        filterTo, setFilterTo,
        search, setSearch,
        activeStatus, setActiveStatus,
        exporting,
        counts,
        displayedActive,
        displayedHistory,
        hasHistoryToExport,
        exportXlsx,
    } = useOrderListData(token)

    const openOrder = order => navigate(`/orders/${order.id}`)
    const newOrders = displayedActive.filter(o => o.status === 'open')
    const inProgressOrders = displayedActive.filter(o => o.status === 'in_progress')

    return (
        <div>
            {loading ? (
                <div className="master-loading">Загрузка...</div>
            ) : (
                <div className="master-page">
                    <div className="master-filters">
                        <div className="master-periods">
                            {[{ value: 'today', label: 'Сегодня' }, { value: 'week', label: 'Неделя' }, { value: 'month', label: 'Месяц' }, { value: 'custom', label: 'Период' }].map(p => (
                                <button key={p.value} type="button" aria-pressed={period === p.value} onClick={() => setPeriod(p.value)}>
                                    {p.label}
                                </button>
                            ))}
                        </div>
                        {period === 'custom' && (
                            <DateRangeFields from={filterFrom} to={filterTo} onFromChange={setFilterFrom} onToChange={setFilterTo} />
                        )}
                        <div className="master-search">
                            <i className="ti ti-search" aria-hidden="true" />
                            <input
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                                aria-label="Поиск"
                                placeholder="Поиск по авто, клиенту, гос. номеру..."
                            />
                        </div>
                        {hasHistoryToExport && (
                            <button type="button" className="master-export" onClick={exportXlsx} disabled={exporting}>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>
                                {exporting ? 'Загрузка...' : 'xlsx'}
                            </button>
                        )}
                    </div>

                    <div className="master-tiles">
                        {metricConfig.map(m => {
                            const isActive = activeStatus === m.key
                            const dimmed = activeStatus !== 'all' && !isActive
                            const subtext = getMetricSubtext(m.key, counts)
                            return (
                                <div
                                    key={m.key}
                                    className="ros-tile"
                                    role="button"
                                    tabIndex={0}
                                    aria-pressed={isActive && m.key !== 'all'}
                                    data-dimmed={dimmed}
                                    onClick={() => setActiveStatus(prev => prev === m.key ? 'all' : m.key)}
                                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveStatus(prev => prev === m.key ? 'all' : m.key) } }}
                                    style={{ gridArea: m.area, background: m.bg }}
                                >
                                    <div style={{ fontSize: '20px', fontWeight: '700', color: 'white' }}>{counts[m.key] || 0}</div>
                                    {subtext && (
                                        <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.65)', margin: '2px 0' }}>
                                            {subtext}
                                        </div>
                                    )}
                                    <div style={{ fontSize: '11px', fontWeight: '600', color: 'white', opacity: 0.9 }}>{m.label}</div>
                                </div>
                            )
                        })}
                    </div>

                    <section className="master-card">
                        <p className="master-card-title">
                            Актуальные диагностики <span className="master-count">{displayedActive.length}</span>
                        </p>
                        {displayedActive.length === 0 ? (
                            <p className="master-empty"><i className="ti ti-clipboard-check" aria-hidden="true" />Нет диагностик</p>
                        ) : (
                            <>
                                {newOrders.length > 0 && (
                                    <div className="master-group">
                                        <div className="master-group-label">
                                            <i className="ti ti-clock" aria-hidden="true" />
                                            Новые
                                        </div>
                                        <div className="master-list">
                                            {newOrders.map(o => (
                                                <OrderCard
                                                    key={o.id}
                                                    order={o}
                                                    onClick={openOrder}
                                                    showMechanic={false}
                                                    showMaster={true}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {inProgressOrders.length > 0 && (
                                    <div className="master-group">
                                        <div className="master-group-label" data-tone="progress">
                                            <i className="ti ti-tool" aria-hidden="true" />
                                            В работе
                                        </div>
                                        <div className="master-list">
                                            {inProgressOrders.map(o => (
                                                <OrderCard
                                                    key={o.id}
                                                    order={o}
                                                    onClick={openOrder}
                                                    showMechanic={false}
                                                    showMaster={true}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </section>

                    <section className="master-card">
                        <p className="master-card-title">
                            История диагностик <span className="master-count">{displayedHistory.length}</span>
                        </p>
                        {displayedHistory.length === 0
                            ? <p className="master-empty"><i className="ti ti-history" aria-hidden="true" />Нет диагностик за период</p>
                            : <div className="master-list">
                                {displayedHistory.map(o => (
                                    <OrderCard
                                        key={o.id}
                                        order={o}
                                        onClick={openOrder}
                                        showMechanic={false}
                                        showMaster={true}
                                    />
                                ))}
                            </div>
                        }
                    </section>
                </div>
            )}
        </div>
    )
}
